import type { UIAppConfig } from '@sydle/ui-app';
import { getConfig, getRouter } from '@sydle/ui-utils';

export enum ServiceDeskRoutes {
  HOME = 'home',
  SEARCH = 'search',
  MY_PANEL = 'my-panel',
  TICKET = 'ticket',
  PATH_WITH_ID = 'path-with-id',
  ACCESSIBILITY = 'accessibility',
}

export class RouterHelper {
  static go(path: string): boolean {
    window.parent.history.pushState(null, document.title, path);
    return window.parent.dispatchEvent(new PopStateEvent('popstate'));
  }
  static replace(path: string): boolean {
    window.history.replaceState(null, document.title, path);
    return window.dispatchEvent(new PopStateEvent('popstate'));
  }

  static isAuthRoute(pathName: string | 'currentRoute'): boolean {
    const authRoute = getConfig<UIAppConfig>('ui-app')?.authRoute;

    switch (pathName) {
      case 'currentRoute':
        return getRouter()?.location?.route?.name?.includes(authRoute);
      default:
        return pathName?.includes(authRoute);
    }
  }
}
